export default __webpack_public_path__ + "static/media/left_arrow.a86fd888.svg";